"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimISOStringMilliseconds = exports.createISOWithoutMillisecond = exports.createDTDayInDefaultTZ = exports.getDateString = exports.areDatesEqual = exports.parsePunchTime = exports.convertTimeStringToMilitaryTimeString = exports.convertTimeStringToJsTimeString = exports.getTimeString = void 0;
/* eslint-disable no-restricted-globals */
var luxon_1 = require("luxon");
/**
 * get time string in 12hr or 24hr format
 * E.g., getTimeString(Wed Apr 15 2020 19:00, true) return 19:00
 * E.g., getTimeString(Wed Apr 15 2020 19:00, false) return 7:00 pm
 */
var getTimeString = function (date, militaryTime) {
    return militaryTime
        ? date.toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
        : date.toLocaleString(luxon_1.DateTime.TIME_SIMPLE);
};
exports.getTimeString = getTimeString;
/**
 * appends :00 to the result of `convertTimeStringToMilitaryTimeString`.
 * This is to put it in the correct string format for the JS Date object
 * to consume.
 */
var convertTimeStringToJsTimeString = function (time) {
    return "".concat((0, exports.convertTimeStringToMilitaryTimeString)(time), ":00");
};
exports.convertTimeStringToJsTimeString = convertTimeStringToJsTimeString;
/**
 * Converts a string in for format of 12:30 am to 12:30 military time.
 */
var convertTimeStringToMilitaryTimeString = function (time) {
    var _a = time.split(' '), timeString = _a[0], amPm = _a[1];
    var _b = timeString.split(':'), hour = _b[0], minutes = _b[1];
    if (amPm === 'am') {
        if (Number(hour) < 12) {
            return timeString;
        }
        return "00:".concat(minutes);
    }
    if (Number(hour) < 12) {
        return "".concat(Number(hour) + 12, ":").concat(minutes);
    }
    return "12:".concat(minutes);
};
exports.convertTimeStringToMilitaryTimeString = convertTimeStringToMilitaryTimeString;
/**
 * @description Parses the punchTime string and returns a new Date object using selectedDate
 * @param punchTime The time string formatted as "hh:mm am/pm"
 * @param selectedDate The date object used with `punchTime` to generate the returned date object
 * @param useMilitaryTime Parses the punch time in 24hr format if true, else uses 12hr format
 * @returns DateTime
 */
var parsePunchTime = function (punchTime, selectedDate, useMilitaryTime) {
    //strip off meridiem designation
    var time = punchTime.split(' ')[0].split(':');
    var hours = parseInt(time[0]);
    var minutes = parseInt(time[1]);
    // convert to 24hr format
    if (!useMilitaryTime) {
        if (hours === 12) {
            hours = 0;
        }
        var sign = punchTime.split(' ')[1];
        if (sign === 'pm') {
            hours += 12;
        }
    }
    return selectedDate.set({
        hour: hours,
        minute: minutes
    });
};
exports.parsePunchTime = parsePunchTime;
/**
 * Compare if two dates without time are equal
 * E.g., Wed Apr 15 2020 19:00 is equal to Wed Apr 15 2020 11:00
 */
var areDatesEqual = function (date1, date2) {
    return (date1.day === date2.day &&
        date1.month === date2.month &&
        date1.year === date2.year);
};
exports.areDatesEqual = areDatesEqual;
/**
 * Converts Date object obtained from AtoZDatepicker to "yyyy-MM-dd" string.
 * Thu Feb 04 2021 00:00:00 GMT-0800 (Pacific Standard Time) -> 2021-02-04
 * Thu Feb 04 2021 00:00:00 GMT+0800 (Irkutsk Standard Time) -> 2021-02-04
 */
function getDateString(day) {
    if (day instanceof luxon_1.DateTime) {
        return luxon_1.DateTime.fromObject({
            year: day.year,
            month: day.month,
            day: day.day
        }).toISODate();
    }
    return luxon_1.DateTime.fromObject({
        year: day.getFullYear(),
        month: day.getMonth() + 1,
        day: day.getDate()
    }).toISODate();
}
exports.getDateString = getDateString;
/**
 * Creates DateTime with default timezone using year, month, day of JS Date.
 * Used to convert day selected in AtoZDatepicker to the DateTime, which is used for pulling AA data in order to display it on that day, regardless of the browser TZ.
 * Thu Feb 04 2021 00:00:00 GMT-0800 (Pacific Standard Time) -> 2021-02-04T00:00:00.000-08:00
 * Thu Feb 04 2021 00:00:00 GMT+0800 (Irkutsk Standard Time) -> 2021-02-04T00:00:00.000-08:00
 */
function createDTDayInDefaultTZ(day) {
    if (!luxon_1.DateTime.fromJSDate(day).isValid) {
        return luxon_1.DateTime.fromJSDate(day);
    }
    return luxon_1.DateTime.fromFormat(getDateString(day), 'y-MM-dd');
}
exports.createDTDayInDefaultTZ = createDTDayInDefaultTZ;
/**
 * Create DateTime string in ISO format without millisecond
 * 2022-04-06T06:15:24.123-07:00 -> 2022-04-06T06:15:24-07:00 the required format for deletePunchAPI
 */
function createISOWithoutMillisecond(dateTime) {
    return dateTime
        .set({ millisecond: 0 })
        .toISO({ suppressMilliseconds: true });
}
exports.createISOWithoutMillisecond = createISOWithoutMillisecond;
/**
 * Converts a DateTime instance to a ISO string, minus the milliseconds.
 * This is a standard ISO string: '1982-05-25T00:00:00.000Z'
 * This function mutates that into: '1982-05-25T00:00:00Z'
 */
function trimISOStringMilliseconds(dateTime) {
    return dateTime
        .toUTC()
        .set({ millisecond: 0 })
        .toISO({ suppressMilliseconds: true });
}
exports.trimISOStringMilliseconds = trimISOStringMilliseconds;
